import { render, staticRenderFns } from "./BusinessDesign.vue?vue&type=template&id=79f6c18a&"
import script from "./BusinessDesign.vue?vue&type=script&lang=js&"
export * from "./BusinessDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports